<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.invoices_issuing.step4.add_product_plural') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-8 overflow-x-auto overflow-y-auto"
        :style="mobileVersion ? 'height: 80vh;' : 'height: 60vh;'">
        <el-form class="h-full flex flex-row overflow-y-auto" :model="form" ref="ruleForm" :rules="rules">
          <step-4-product-table v-model="form.products" :id-cliente="idCliente" :ruleForm="$refs.ruleForm" />
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary" :text="$t('app.cancel')" />
        <base-button mode="primary" class="w-full mx-2" :text="$t('invoices.invoices_issuing.step4.add_product')" @click="addProduct('ruleForm')" />
      </div> 
    </template>
  </base-dialog-button>
</template>
    
<script>
import { i18n } from '@/i18n'

import { getProductsImpuestosPag } from '@/services/configurations/getProductsImpuestosPag'

import Step4ProductTable from '@/components/Step4ProductTable.vue'

export default {
  /* eslint-disable camelcase */
  name: 'import-products-dialog',
  components: {
    Step4ProductTable
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: [Number, String]
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      activeName: 'es',
      form: this.getDefaultForm(),
      rules: {},
      zeroTax: []
    }
  },
  computed: {
    hasOperationType: function () {
      return this.operationType === 1 || this.operationType === 2 || this.operationType === 3
    },
    operationType: function () {
      return this.$store.getters['invoicesIssuing/2/form']?.tipoImpuestoFactura
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_OPERACION_TRIBUTACION'].filter(x => x.id === this.operationType)[0].name
    },
    isTax: function () {
      return this.form.products.length > 0
    },
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = value
        this.zeroTax = []
        this.resetForm()
      }
    },
  },
  mounted () {
  },
  methods: {
    getDefaultForm: function () {
      return {
        products: []
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    doNext: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            this.showProducts = false
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    doBack: function (ruleForm) {
      this.showProducts = true
    },
    addProduct: function (formName) {
      try {
        this.$store.commit('setIsLoading', true)
        const data = this.form.products
        // Comprobamos si hay productos seleccionados  
        if (data.length > 0) {
          const addedProducts = []
          // Comprobamos que los productos seleccionados contengan total
          if (!data.some(element => 
            element.totalConImpuesto === undefined || 
            element.totalConImpuesto === null || 
            element.totalConImpuesto === '')) {
            data.forEach(element => {
              this.$refs[formName].validate(valid => {
                if (valid) {
                  if (this.hasOperationType) { 
                    this.zeroTax = [{
                      Name: this.tiposOperacion || this.operationType,
                      TaxType: '01',
                      TaxRate: 0,
                      TaxCategory: 0,
                      idImpuesto: null         
                    }]
                  }
                  const params = {
                    descuentos: [
                      {
                        incluyeDescuento: element.editDescuento || false,
                        descuento: element.editDescuento ? element.descuento : '',
                        cuota: element.cuota || null
                      }
                    ],
                    // taxes: Impuestos seleccionados para la línea (Actualmente limitado a 1)
                    // taxes: element.Taxes,
                    taxes: this.hasOperationType ? this.zeroTax : element.Taxes,
                    // impuestos: Impuestos disponibles para modificación en línea
                    // impuestos: element.Impuestos,
                    impuestos: this.hasOperationType ? this.zeroTax : element.Taxes,
                    idCliente: this.idCliente || data[0].idCliente,
                    idProducto: element.idProducto || null,
                    codProducto: element.ArticleCode || null,
                    descripcion: element.ItemDescription || null,
                    precioUnitario: element.UnitPriceWithoutTax || null,
                    cantidad: element.cantidad || element.cantidad === 0 ? element.cantidad : null,
                    subtotal: element.subtotal || element.subtotal === 0 ? element.subtotal : null,
                    total: element.total || element.total === 0 ? element.total : null,
                    totalConImpuesto: element.totalConImpuesto || element.totalConImpuesto === 0 ? element.totalConImpuesto : null,
                    UnitOfMeasure: element.UnitOfMeasure || null,
                    additionalLineItemInformation: element.additionalLineItemInformation || null
                  }
                  
                  addedProducts.push(params)
                } else {
                  this.doFeedback(i18n.t('feedback.error.process_data_error'))
                }
              })  
            })
            this.$emit('applyDialog', addedProducts)
            this.toggleDialog()
          } else {
            this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_total'))
          }
        } else {
          this.doFeedback(i18n.t('app.select_data'))
        }
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback(error)
      } finally {
        this.showProducts = false
        this.$store.commit('setIsLoading', false)
      }
    },
    getProductTax: async function (product, params = false) {
      try {
        const data = await getProductsImpuestosPag({}, { idProducto: product.idProducto || product })
        return params ? data : data.Respuesta[0].TaxRate
      } catch (error) {
        this.doFeedback()
      } 
    }
  }
}
</script>
<style scoped>
</style>
